module.exports = __webpack_public_path__ + "static/media/erigging.ca2e0497.png";